import template from './add-receipt.html';

import { ComponentBase } from "../Common/componentBase";
import { RegisterDefaultComponent } from "../Common/componentsHelpers";


export class AddReceiptViewModel extends ComponentBase {
    constructor(params) {
        super(params);

        this.addReceiptPath = $.cdh.global.addReceipt;
    }


}

RegisterDefaultComponent('add-receipt', template, AddReceiptViewModel);